// src/pages/admin/bookings/bookingTypes.ts

export type BookingStatus =
  | "new"
  | "pending"
  | "hold"
  | "confirmed"
  | "cancelled"
  | "checked_in"
  | "checked_out"
  | "archived"
  | string;

export type BookingListItem = {
  id: number;
  property_id?: number | null;
  property_title?: string | null;
  property_slug?: string | null;

  customer_id?: number | null;
  customer_name?: string | null;

  check_in?: string | null;
  check_out?: string | null;

  guests_total?: number | null;
  status?: BookingStatus | null;

  created_at?: string | null;
  updated_at?: string | null; // ✅ ADD THIS
};

export type BookingDetails = BookingListItem & {
  internal_notes?: string | null;
  booking_inquiry_id?: number | null;

  customer?: BookingCustomer | null;
  property?: BookingProperty | null;
};


export type BookingCustomer = {
  id?: number | null;
  full_name?: string | null;
  email?: string | null;
  phone?: string | null;
};

export type BookingProperty = {
  id?: number | null;
  slug?: string | null;
  title?: string | null;
};

export type PagedResponse<T> = {
  ok?: boolean;
  items?: T[];
  total?: number;
  hasMore?: boolean;
  error?: string;
};

export const DEFAULT_BOOKING_STATUSES: Array<{ value: string; label: string }> = [
  { value: "", label: "All" },
  { value: "new", label: "New" },
  { value: "pending", label: "Pending" },
  { value: "hold", label: "Hold" },
  { value: "confirmed", label: "Confirmed" },
  { value: "checked_in", label: "Checked-in" },
  { value: "checked_out", label: "Checked-out" },
  { value: "cancelled", label: "Cancelled" },
  { value: "archived", label: "Archived" },
];

export function safeStr(v: any, fallback = ""): string {
  if (v === null || v === undefined) return fallback;
  const s = String(v);
  return s.trim() ? s : fallback;
}

export function toISODateInput(v?: string | null): string {
  // Accepts "YYYY-MM-DD" or ISO datetime, returns "YYYY-MM-DD" or ""
  const s = safeStr(v, "");
  if (!s) return "";
  // Already a date-only
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) return s;
  const d = new Date(s);
  if (Number.isNaN(d.getTime())) return "";
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function fmtDate(dateStr?: string | null): string {
  const s = toISODateInput(dateStr);
  if (!s) return "—";
  return s;
}

export function nightsBetween(checkIn?: string | null, checkOut?: string | null): number | null {
  const a = toISODateInput(checkIn);
  const b = toISODateInput(checkOut);
  if (!a || !b) return null;
  const d1 = new Date(a + "T00:00:00");
  const d2 = new Date(b + "T00:00:00");
  const ms = d2.getTime() - d1.getTime();
  if (Number.isNaN(ms)) return null;
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

export function fmtDateRange(checkIn?: string | null, checkOut?: string | null): string {
  const a = fmtDate(checkIn);
  const b = fmtDate(checkOut);
  if (a === "—" && b === "—") return "—";
  if (a !== "—" && b === "—") return `${a} → —`;
  if (a === "—" && b !== "—") return `— → ${b}`;
  return `${a} → ${b}`;
}

export function clampInt(n: any, fallback: number, min: number, max: number): number {
  const x = Number(n);
  if (!Number.isFinite(x)) return fallback;
  return Math.max(min, Math.min(max, Math.floor(x)));
}
